import React from "react";
import { useTranslation } from "react-i18next";
import ClaimInfoTable from "./ClaimInfoTable";
import AppOutlineButton from "components/ui/AppOutlineButton";

const ClaimInfo = (props) => {
  let { careemOrder } = props;
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex justify-center">
        <AppOutlineButton 
          variant="secondary"
          size="lg"
          onClick={props.getCareemORderStatus}
        >
          {t("Refresh for latest info")}
        </AppOutlineButton>
      </div>
      <ClaimInfoTable {...{ careemOrder }} />
    </div>
  );
};

export default ClaimInfo;
